import * as LabelPrimitive from '@radix-ui/react-label';
import { forwardRef, type ComponentPropsWithoutRef, type ElementRef } from 'react';
import { cn } from '../lib/cn';

export type LabelProps = ComponentPropsWithoutRef<typeof LabelPrimitive.Root>;

export const Label = forwardRef<ElementRef<typeof LabelPrimitive.Root>, LabelProps>(
  ({ className, ...rest }, ref) => (
    <LabelPrimitive.Root
      ref={ref}
      className={cn(
        'block text-xs font-medium text-fg-subtle mb-1.5 tracking-tight',
        className,
      )}
      {...rest}
    />
  ),
);
Label.displayName = 'Label';
